import axios from "axios";
import { TInvoiceActivityRow } from "./types";

export async function getInvoiceActivity(invoiceId: string) {
  return await axios
    .get<TInvoiceActivityRow[]>(
      `${process.env.REACT_APP_SERVER_URL}/api/v1/company/invoice/${invoiceId}/activity`
    )
    .then((res) => res.data);
}

